export default __webpack_public_path__ + "static/media/circlered.794b3026.png";